import type { ReactNode } from 'react';

import CheckIcon from '~public/assets/icons/check.svg';

import { CheckboxInput, CheckBoxSquare, CheckBoxWrapper } from './styled';

type IProps = React.InputHTMLAttributes<HTMLInputElement> & {
	children: ReactNode;
};

// TODO: reimplement with native checkbox features instead of svg and vusiual spans
export const Checkbox = ({
	children,
	disabled,
	className,
	...props
}: IProps) => {
	return (
		<CheckBoxWrapper className={className} disabled={disabled}>
			<CheckboxInput type="checkbox" {...props} />
			<CheckBoxSquare>
				<CheckIcon />
			</CheckBoxSquare>
			{children}
		</CheckBoxWrapper>
	);
};
